<div class="om-audio-recorder">
  <!-- Hidden file input for audio upload -->
  <input
    id="audioFileInput"
    type="file"
    accept="audio/*"
    class="hidden"
    (change)="onFileUpload($event)"
  />

  @switch (state()) {
  <!-- ── Idle state: record or upload ──────────────── -->
  @case ('idle') {
  <div class="flex items-center gap-3">
    <!-- Record button -->
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="startRecording()"
      aria-label="Record audio"
    >
      <span class="material-symbols-outlined !text-[22px]">mic</span>
    </button>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">
        {{ title() || 'Audio' }}
      </p>
      <p class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
        Graba o sube un audio
      </p>
    </div>

    <!-- Upload button -->
    <button
      type="button"
      class="p-2.5 rounded-xl border border-white/50 dark:border-white/[0.15] bg-white/60 dark:bg-white/[0.06] backdrop-blur-sm hover:bg-white/80 dark:hover:bg-white/[0.12] text-slate-400 hover:text-primary transition-all cursor-pointer"
      (click)="triggerUpload()"
      aria-label="Upload audio"
    >
      <span class="material-symbols-outlined !text-[20px]">upload_file</span>
    </button>
  </div>

  <!-- Idle waveform -->
  <div class="mt-3">
    <om-waveform-bars [isAnimating]="true" [heightPx]="40" />
  </div>
  }

  <!-- ── Recording state ──────────────────────────── -->
  @case ('recording') {
  <div class="flex items-center gap-3">
    <!-- Stop button -->
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-red-500 text-white flex items-center justify-center shadow-lg shadow-red-500/25 animate-pulse hover:bg-red-600 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="stopRecording()"
      aria-label="Stop recording"
    >
      <span class="material-symbols-outlined !text-[22px]">stop</span>
    </button>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold text-red-500 flex items-center gap-1.5">
        <span class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
        Grabando...
      </p>
      <p class="text-xs text-slate-500 dark:text-slate-400 font-mono mt-0.5">
        {{ formattedDuration() }}
      </p>
    </div>
  </div>

  <!-- Live waveform -->
  <div class="mt-3">
    <canvas #waveCanvas class="w-full h-10"></canvas>
  </div>
  }

  <!-- ── Recorded / Playing / Paused state ─────────── -->
  @default {
  <div class="flex items-center gap-3">
    <!-- Play/Pause button -->
    @if (state() === 'playing') {
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="pause()"
      aria-label="Pause"
    >
      <span class="material-symbols-outlined !text-[22px]">pause</span>
    </button>
    } @else {
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="play()"
      aria-label="Play"
    >
      <span class="material-symbols-outlined !text-[22px]">play_arrow</span>
    </button>
    }

    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">
        {{ title() || 'Audio' }}
      </p>

      <!-- Waveform + duration -->
      <div class="flex items-center gap-2 mt-1">
        <canvas #waveCanvas class="flex-1 h-8"></canvas>
        <span class="text-xs text-primary font-mono shrink-0">
          {{ formattedCurrentTime() }} / {{ formattedDuration() }}
        </span>
      </div>
    </div>

    <!-- Delete button -->
    <button
      type="button"
      class="p-2 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer"
      (click)="clearAudio()"
      aria-label="Delete audio"
    >
      <span class="material-symbols-outlined !text-[18px]">delete</span>
    </button>
  </div>
  } }
</div>
